import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types';
import { Grid, withStyles, Typography } from '@material-ui/core';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { styles } from '../../styles';
import * as actions from '../../../store/actions/members';

class PostLogin extends Component {

    constructor(props){
        super(props);
        this.state = {
            showRegistrationForm: true,

        }
    }

    componentDidMount = () => {
        const idToken= this.props.memberData && this.props.memberData.response && this.props.memberData.response.id_token;
		if(idToken) {
            this.props.dispatch(actions.getMemberDetails(idToken, () => {
                			// TODO: any post processing after action is executed successfully
             }));
        }
	}

    render() {
        return (
            <Fragment>
                <Grid container justify="center" alignItems="center" style={{ padding: "20px" }}>
                    <Typography variant="h6">You are being redirected...</Typography>
                </Grid>
            </Fragment>
        )
    }
}

PostLogin.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


const mapDispatchToProps = (dispatch) => {
    return { dispatch };
};

const mapStateToprops = (state) => {
    return {
        loading: state.members && state.members.loading,
        memberData: state.members && state.members.memberData,
        memberDetails: state.members && state.members.memberDetails

    };
};



export default compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToprops, mapDispatchToProps)
)(PostLogin); 